export const SEARCH_MEDICAL_HISTORY_REQUESTED = 'SEARCH_MEDICAL_HISTORY_REQUESTED';
export const SEARCH_MEDICAL_HISTORY_SUCCEED = 'SEARCH_MEDICAL_HISTORY_SUCCEED';
export const SEARCH_MEDICAL_HISTORY_FAILED = 'SEARCH_MEDICAL_HISTORY_FAILED';
